import React from "react";
import {
  Checkbox,
  FormControlLabel,
  MenuItem,
  TextField,
} from "@mui/material";

export interface TriggerFieldInputsProps {
  field: { name: string; type?: string; description?: string; required?: boolean };
  value: any;
  onChange: (value: any) => void;
  error?: boolean;
  options?: string[] | null;
}

function toTitleCase(s: string): string {
  return s
    .replace(/_/g, " ")
    .split(" ")
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(" ");
}

export default function TriggerFieldInputs({ field, value, onChange, error, options }: TriggerFieldInputsProps) {
  const type = field.type || "string";
  const val = value ?? "";
  const label = `${toTitleCase(field.name)}${field.required ? " *" : ""}`;

  // Prose enum dropdown: when options are available, render a Select
  if (options && options.length > 0) {
    return (
      <TextField
        select
        label={label}
        helperText={field.description}
        value={val}
        onChange={(e) => onChange(e.target.value)}
        error={error}
        fullWidth
        size="small"
        sx={{ mb: 2 }}
        SelectProps={{ native: false }}
      >
        {options.map((opt) => (
          <MenuItem key={opt} value={opt}>
            {opt}
          </MenuItem>
        ))}
      </TextField>
    );
  }

  if (type === "boolean") {
    return (
      <FormControlLabel
        control={
          <Checkbox
            checked={val === "true" || val === true}
            onChange={(e) => onChange(e.target.checked ? "true" : "false")}
          />
        }
        label={label}
      />
    );
  }

  if (type === "number" || type === "integer") {
    return (
      <TextField
        label={label}
        helperText={field.description}
        type="number"
        inputProps={{ step: type === "integer" ? 1 : "any" }}
        value={val}
        onChange={(e) => onChange(e.target.value)}
        error={error}
        fullWidth
        size="small"
        sx={{ mb: 2 }}
      />
    );
  }

  if (type === "array" || type === "object") {
    return (
      <TextField
        label={`${label} (JSON)`}
        helperText={field.description || "Enter valid JSON"}
        multiline
        rows={3}
        value={val}
        onChange={(e) => onChange(e.target.value)}
        error={error}
        fullWidth
        size="small"
        sx={{ mb: 2 }}
      />
    );
  }

  // default: string / unknown type
  return (
    <TextField
      label={label}
      helperText={field.description}
      value={val}
      onChange={(e) => onChange(e.target.value)}
      error={error}
      fullWidth
      size="small"
      sx={{ mb: 2 }}
    />
  );
}
